export default function validation(response, messages) {
  response.error.validationErrors.forEach((error) => {
    if (error.message.indexOf('CHECK_S_NUMBER_MISSING') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.checksNumberMissing',
      });
    }
    if (error.message.indexOf('MUST_BE_PDF') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.mustBePdf',
      });
    }
    if (error.message.indexOf('PARAMETRAGE_MISSING') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.parametrageMissing',
      });
    }
  });
}
